module.exports = __webpack_public_path__ + "img/car-circle-bolt.243da476.svg";